<script lang="ts">
    import { sendUIInteractionAnalyticsEvent } from "@app/services/analytics/analytics-send-event";

    import SideNav from "./SideNav.svelte";

    const activator = document.getElementById("sidenavActivator");
    const container = document.getElementById("glosbe-components");

    if (activator && container) {
        const sideNav = new SideNav({
            target: container,
            props: { onClose: toggleSideNav },
        });
        let open = false;
        function toggleSideNav() {
            open = !open;
            sideNav.$set({ open });

            sendUIInteractionAnalyticsEvent({
                action: "sidenav",
                label: open ? "open" : "close",
            });
        }

        activator.addEventListener("click", toggleSideNav);
    }
</script>
